import EasyNeedOffer from './EasyNeedOffer.jsx';

export default EasyNeedOffer;


// WEBPACK FOOTER //
// ./components/partials/easy-need-offer/index.js